const style = (theme) => ({
  root: {
    position: 'relative',

  },
  accordionTitle: {
    color: theme.colors[0],
    margin: '30px 0px',
    fontSize: '24px',

  },
  accordionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  accordionContent: {
    '& a': {
      color: 'currentColor',
      textDecoration: 'underline',
    },
    '& ul': {
      marginBottom: '1em',
      '& li': {
        position: 'relative',
        paddingLeft: '20px',
        '&:not(:last-of-type)': {
          marginBottom: '5px',
        },
        '&:before': {
          content: '""',
          width: '5px',
          height: '5px',
          backgroundColor: theme.colors[0],
          position: 'absolute',
          left: '4px',
          top: '11px',
          display: 'block',
          borderRadius: '50%',
        },
      },
    },
    '& strong': {
      fontWeight: 'bold',
    },
    '& sm, & i': {
      fontStyle: 'italic',
    },
  },

})

export default style
